module.exports = __webpack_public_path__ + "static/media/manual-capture-button.2df54dfd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/manual-capture-button.svg
// module id = 108
// module chunks = 0